export default __webpack_public_path__ + "static/media/token-jump.338e6531.png";